<template>
  <v-container fluid>
    <Title
      v-if="$vuetify.breakpoint.smAndUp"
      :src="'favorites'"
      :text="'Favorites'"
    />
    <v-row class="background-color-white">
      <XsTitle v-if="$vuetify.breakpoint.xsOnly" :text="'Favorites'" />
      <v-col>
        <Loader v-if="!favorites" />
        <div v-else-if="!favorites.length">
          <EmptyState>
            <div class="align-center d-flex flex-column">
              <div class="text-center">
                &ldquo;Favorite&rdquo; the items you like to order!
              </div>
              <br />
              <div class="text-center">
                Click the heart button
                <img
                  alt="heart button to favorite product"
                  class="mx-1 vertical-align-middle"
                  src="@/assets/favorites/desktop/favorite-active.svg"
                  height="26"
                  width="30"
                />
                <br />
                on your favorite items.
              </div>
            </div>
          </EmptyState>
        </div>
        <div v-else>
          <v-row class="mb-0 mb-sm-6 mr-sm-0 px-3 px-sm-6">
            <v-col
              v-for="(product, index) in favorites"
              class="mb-sm-5 pa-0 pa-sm-3 position-relative"
              :key="index"
              cols="6"
              md="3"
              xl="2"
            >
              <Product
                :product="product"
                :size="$vuetify.breakpoint.xsOnly ? 'xs' : 'md'"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import EmptyState from "@/components/EmptyState.vue";
import Loader from "@/components/UI/Loader.vue";
import Product from "@/components/Product/index.vue";
import Title from "@/components/UI/Title.vue";
import XsTitle from "@/components/UI/Xs/Title.vue";

export default {
  name: "FavoritesView",
  components: { EmptyState, Loader, Product, Title, XsTitle },
  computed: {
    ...mapState({
      favorites: (state) => state.favorites.data,
    }),
  },
};
</script>
